import Assistants from 'builders/builderAssistant/configMode/Page';

export default function AssistantBuilder() {
    return (
        <Assistants />
    );
}
